// extracted by mini-css-extract-plugin
module.exports = {"carInfo":"CarInfo_carInfo__3_fcu","open":"CarInfo_open__2zQ_1","dummy":"CarInfo_dummy__3YvFK","border":"CarInfo_border__2Jijw"};